import { Navigate } from "react-router-dom";
import MarketingPage from "../dasboard-component/MarketingPage";
import { useAuth } from "../context/AuthContext";

const AuthenticatedRoute = () => {
  // Read from context; token is in httpOnly cookie
  const { user, loading } = useAuth();
  if (loading) return null;
  const isAdmin = !!user?.isAdmin;
  const adminType = user?.adminRole;

  // If user is authenticated, redirect immediately
  if (user) {
    if (isAdmin) {
      if (adminType === "SuperAdmin") {
        return <Navigate to="/DsportSuperAdmin" replace />;
      } else if (adminType === "Admin") {
        return <Navigate to="/DsportAdmin" replace />;
      }
    } else {
      return <Navigate to="/main-dashboard" replace />;
    }
  }

  // If not authenticated, show marketing page
  return <MarketingPage />;
};

export default AuthenticatedRoute;
